module.exports = __webpack_public_path__ + "img/floor_bg.04eb9e49.jpg";